import TextAlign from './extension-text-align';
import UniqueID from './extension-unique-id';

export const extensionTypes = {
  // NOTE: our own extension
  UniqueID: UniqueID.type,

  // NOTE: titap extension
  TextAlign: 'textAlign',
};

export default [
  UniqueID.extention.configure({
    types: ['answer', 'answerSection'],
  }),
  TextAlign,
];
